import React from "react";
import RegisterPageScaffold from "../SHARED/RegisterPageScaffold";
import { getRegisterVariant } from "../SHARED/registerPageConfig";
import { useRegister } from "../SHARED/hooks/useRegister";
import RegisterStandardFormBody from "../SHARED/components/RegisterStandardFormBody";
import RegisterPageDialogs, { RegisterPageBottomBar } from "../SHARED/components/RegisterPageDialogs";

const VARIANT_ID = "internalUser";

const InternalUserRegister = () => {
  const reg = useRegister(VARIANT_ID);
  const cfg = getRegisterVariant(VARIANT_ID);

  return (
    <RegisterPageScaffold
      config={cfg}
      minHeight={cfg.minHeight}
      bottomBar={<RegisterPageBottomBar reg={reg} />}
      dialogs={<RegisterPageDialogs reg={reg} />}
    >
      <RegisterStandardFormBody reg={reg} />
    </RegisterPageScaffold>
  );
};

export default InternalUserRegister;
